import { FormContent } from '../../../components/bookingConfirmationCard/bookingConfirmationFun';

export default function AccAddress({ accDetails }) {
    return (
        <div>
            <h2 className='orgAccountH2'>Address</h2>
            <div className='orgAccountSecDiv'>
                <div className='orgAccountGrid'>
                    <FormContent
                        id='orgExtraStyle'
                        label='Company Name'
                        answer={accDetails?.companyName}
                        className='borderNone width50'
                    />
                    <FormContent
                        id='orgExtraStyle'
                        label='Address Line 1'
                        answer={accDetails?.address?.addressLine1}
                        className='borderNone width50'
                    />
                </div>
                <div className='orgAccountGrid'>
                    <FormContent
                        id='orgExtraStyle'
                        label='Address Line 2'
                        answer={accDetails?.address?.addressLine2 || 'N/A'}
                        className='borderNone width50'
                    />
                    <FormContent
                        id='orgExtraStyle'
                        label='City'
                        answer={accDetails?.address?.city}
                        className='borderNone width50'
                    />
                </div>
                <div className='orgAccountGrid'>
                    <FormContent
                        id='orgExtraStyle'
                        label='Pincode'
                        answer={accDetails.address?.pincode}
                        className='borderNone width50'
                    />
                    <FormContent
                        id='orgExtraStyle'
                        label='State'
                        answer={accDetails.address?.state}
                        className='borderNone width50'
                    />
                </div>
                <div className='orgAccountGrid'>
                    <FormContent
                        id='orgExtraStyle'
                        label='Country'
                        answer={accDetails.address?.country}
                        className='borderNone width50'
                    />
                </div>
            </div>
        </div>
    );
}
